(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const elements = [
    ...document.querySelectorAll('[data-reveal-section]'),
    ...document.querySelectorAll('[data-reveal-item]'),
    ...document.querySelectorAll('.ma-section:not(.ma-section--no-motion) .ma-product-card, .ma-goal-card, .ma-comparison-card')
  ];
  const unique = [...new Set(elements)];
  unique.forEach((element, index) => {
    element.classList.add('ma-reveal');
    element.dataset.revealDelay = String(index % 4);
  });
  if (reduceMotion || !('IntersectionObserver' in window)) {
    unique.forEach((element) => element.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  unique.forEach((element) => observer.observe(element));
})();
